import { CardWrapper, CardVenueDetails, WorkerBaseCardVariant, CardSubscriptionDetails } from './worker-base-card';

export function WorkerVenueCard({
  venueLogo,
  venueName,
  firstSubDate,
  city,
  href,
  newTab,
  wrapperStyle,
}: WorkerVenueCardProps) {
  const variant: WorkerBaseCardVariant = 'venue';

  return (
    <CardWrapper variant={variant} href={href} newTab={newTab} wrapperStyle={wrapperStyle}>
      <CardVenueDetails variant={variant} logoSrc={venueLogo} city={city} venueName={venueName} />
      <CardSubscriptionDetails firstSubDate={firstSubDate} />
    </CardWrapper>
  );
}

export interface WorkerVenueCardProps {
  venueLogo: string;
  venueName?: string;
  firstSubDate?: string;
  city?: string;
  href?: string;
  newTab?: boolean;
  wrapperStyle?: string;
}
